var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-store" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("products")) + "\n        ")
        ],
        1
      ),
      _c(
        "q-table",
        {
          attrs: {
            data: _vm.rewards,
            columns: _vm.columnsOnView(),
            pagination: _vm.server_pagination,
            loading: _vm.loading,
            "row-key": "name",
            "no-data-label": _vm.$t("no_data_avaliable"),
            "no-results-label": _vm.$t("no_results_found"),
            "loading-label": _vm.$t("loading_data"),
            "rows-per-page-label": _vm.$t("items_per_page"),
            "rows-per-page-options": [5, 10, 50, 100],
            "binary-state-sort": ""
          },
          on: {
            "update:pagination": function($event) {
              _vm.server_pagination = $event
            },
            request: _vm.request
          },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function(props) {
                return [
                  _c("div", { staticClass: "col" }),
                  _c("q-btn", {
                    attrs: {
                      color: "secondary",
                      icon: "fas fa-plus",
                      label: _vm.$t("new")
                    },
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          name: "admin_reward",
                          params: { id: 0 }
                        })
                      }
                    }
                  })
                ]
              }
            },
            {
              key: "header",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                )
              }
            },
            {
              key: "body",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-td",
                      { key: "id", attrs: { "auto-width": "", props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.id) +
                            "\n                "
                        )
                      ]
                    ),
                    _c("q-td", { key: "title", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.title) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "reward_product_type", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              props.row.reward_product_type === "voucher"
                                ? _vm.$t("voucher")
                                : _vm.$t("physical_product")
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "permissions", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              color: "primary",
                              "text-color": "white",
                              label: _vm.getQuantity(props.row.permissions),
                              "no-ripple": ""
                            }
                          },
                          [
                            _c("q-tooltip", [
                              props.row.permissions.areas &&
                              props.row.permissions.areas.length
                                ? _c("p", { staticClass: "tooltip q-mb-sm" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("areas")) +
                                        ":\n                                "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            props.row.permissions.areas
                                              .map(function(a) {
                                                return _vm.getArea(a)
                                              })
                                              .join(", ")
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              props.row.permissions.profiles &&
                              props.row.permissions.profiles.length
                                ? _c("p", { staticClass: "tooltip q-mb-sm" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("profiles")) +
                                        ":\n                                "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            props.row.permissions.profiles
                                              .map(function(a) {
                                                return _vm.getProfile(a)
                                              })
                                              .join(", ")
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              props.row.permissions.user_group &&
                              props.row.permissions.user_group.length
                                ? _c("p", { staticClass: "tooltip q-mb-sm" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("user_group")) +
                                        ":\n                                "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            props.row.permissions.user_group
                                              .map(function(a) {
                                                return _vm.getGroup(a)
                                              })
                                              .join(", ")
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("q-td", { key: "price", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.price) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "must_be_approved", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              props.row.must_be_approved
                                ? _vm.$t("yes")
                                : _vm.$t("no")
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_in_stock", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.qty_in_stock) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_redemptions", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.qty_redemptions) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "max_redemptions_per_user",
                        attrs: { props: props }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.max_redemptions_per_user) +
                            "\n                "
                        )
                      ]
                    ),
                    _c("q-td", { key: "timezone", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.timezone) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "publish_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              props.row.publish_date
                                ? _vm.formatDate(props.row.publish_date)
                                : "-"
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "unpublish_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              props.row.unpublish_date
                                ? _vm.formatDate(props.row.unpublish_date)
                                : "-"
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatus(props.row.status),
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(_vm.getStatus(props.row.status))
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "actions", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "primary",
                              icon: "far fa-list-alt"
                            },
                            on: {
                              click: function() {
                                _vm.view_report_reward = true
                                _vm.selected_product = props.row.id
                                _vm.fetchProductById({
                                  pagination: _vm.product_redeem_pagination
                                })
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("view_redeem_history_tooltip")
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "primary",
                              icon: "fas fa-pencil-alt"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "admin_reward",
                                  params: { id: props.row.actions }
                                })
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            }
          ])
        },
        [
          _c(
            "q-tr",
            { attrs: { slot: "bottom-row" }, slot: "bottom-row" },
            [
              _c(
                "q-td",
                { attrs: { colspan: "100%" } },
                [
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        flat: "",
                        round: "",
                        dense: "",
                        color: "secondary",
                        size: "small",
                        icon: "fas fa-cog"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_modal = true
                        }
                      }
                    },
                    [
                      _c("q-tooltip", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("configure_table_tooltip")) +
                            "\n                        "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return column.name !== "actions" && column.name !== "id"
                      ? _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-4" },
                          [
                            _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fas fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveColumns()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "80vw" } },
          model: {
            value: _vm.view_report_reward,
            callback: function($$v) {
              _vm.view_report_reward = $$v
            },
            expression: "view_report_reward"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header", color: "white" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    { staticClass: "text-black flex justify-between" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.selected_product_name) +
                          "\n                        "
                      ),
                      _c("q-btn", {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: { flat: "", dense: "", icon: "close" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-toolbar",
                {
                  staticClass: "justify-end",
                  attrs: { slot: "header", color: "white" },
                  slot: "header"
                },
                [
                  _c("q-search", {
                    staticClass: "q-my-md",
                    attrs: { color: "white", label: _vm.$t("search") },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.fetchProductById({
                          pagination: _vm.product_redeem_pagination
                        })
                      }
                    },
                    model: {
                      value: _vm.search_product,
                      callback: function($$v) {
                        _vm.search_product = $$v
                      },
                      expression: "search_product"
                    }
                  })
                ],
                1
              ),
              _c("q-table", {
                attrs: {
                  data: _vm.history_redeem,
                  columns: _vm.report_columns,
                  "row-key": "id",
                  flat: "",
                  pagination: _vm.product_redeem_pagination,
                  loading: _vm.loading,
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "rows-per-page-options": [5, 10, 50, 100]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.product_redeem_pagination = $event
                  },
                  request: _vm.fetchProductById
                },
                scopedSlots: _vm._u([
                  {
                    key: "body-cell-status_from",
                    fn: function(props) {
                      return [
                        _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  icon: _vm.getRedeemStatusIcon(
                                    props.row.status_from
                                  ),
                                  color: _vm.getRedeemStatusColor(
                                    props.row.status_from
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.getRedeemStatus(
                                        props.row.status_from
                                      ) || "-"
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "body-cell-status_to",
                    fn: function(props) {
                      return [
                        _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  icon: _vm.getRedeemStatusIcon(
                                    props.row.status_to
                                  ),
                                  color: _vm.getRedeemStatusColor(
                                    props.row.status_to
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.getRedeemStatus(
                                        props.row.status_to
                                      ) || "-"
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }